import React, { useState } from 'react'

// Const
import { PATH_LOGIN } from 'routes/paths'

// Use
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useDesktop } from 'use/media'

// Services
import loadingService from 'services/loading'

// Actions
import { logout } from 'store/modules/auth'

// Components
import Dropdown from 'ui/Dropdown'
import DropdownMenu from 'ui/Dropdown/DropdownMenu'
import DropdownMenuItem from 'ui/Dropdown/DropdownMenuItem'
import Avatar from 'ui/Avatar'
import IconLogout from 'ui/Icons/IconLogOut'
import Container from 'ui/Container'
import Notification from 'components/Notification'

// Assets
import ImageLogoPaytrack from 'assets/images/paytrack-logo.png'
import ImageLogoGlobe from 'assets/images/globe-logo.png'

// Styles
import './Header.scss'

export function Header() {
  const dispatch = useDispatch()
  const history = useHistory()
  const isDesktop = useDesktop()
  const [open, setOpen] = useState(false)
  const user = useSelector((state) => state.auth.user)

  const onLogoutClick = async () => {
    try {
      setOpen(false)
      loadingService.show()
      await dispatch(logout())
    } catch (error) {
      //
    } finally {
      loadingService.hide()
      history.replace(PATH_LOGIN)
    }
  }

  const subMenu = () => {
    return (
      <DropdownMenu
        style={{ width: isDesktop ? '240px' : '150px', float: 'right' }}
      >
        <DropdownMenuItem onClick={onLogoutClick}>
          <IconLogout width="20px" style={{ marginRight: '10px' }} />
          Logout
        </DropdownMenuItem>
      </DropdownMenu>
    )
  }

  return (
    <div className="admin-header">
      <Container>
        <div className="admin-header__top">
          <div className="topbar-left">
            <img
              draggable="false"
              src={ImageLogoPaytrack}
              alt="paytrack logo"
              className="--paytrack-logo"
            />
          </div>

          <div className="topbar-right">
            {/* User */}
            <div className="--user">
              <Dropdown
                overlay={subMenu}
                visible={open}
                trigger={['click']}
                onVisibleChange={(e) => setOpen(e)}
                placement="bottomRight"
                arrow
              >
                <div id="dropdown-custom-components">
                  <div className="user-button is-flex is-flex-direction-row">
                    <div className="--text is-hidden-touch">{user.email}</div>
                    <Avatar
                      name={user.email}
                      image={user.avatar}
                      size="small"
                    />
                  </div>
                </div>
              </Dropdown>
            </div>

            {/* App */}
            <div className="--notification">
              <Notification />
            </div>

            {/* Globe logo */}
            <div className="--logo">
              <img
                draggable="false"
                src={ImageLogoGlobe}
                alt="portal logo"
                className="--globe-logo"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Header
